import { ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootState, IRootThunkDispatch } from "../../redux/store";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";

import ReactSelect, { SingleValue } from "react-select";
import { SelectedBinListInBinGroup } from "../../redux/BinGroup/state";
import {
  addBinToSelectedBinInBinGroupAction,
  changeBinGroupIsActiveAction,
  changeSelectedBinGroupSequenceAction,
  changeSelectedBinInBinGroupAction,
  removeBinFromSelectedBinInBinGroupAction,
} from "../../redux/BinGroup/action";
import AddBinGroupForm from "./AddBinGroupForm";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

function BinGroupForm() {
  const dispatch = useDispatch<IRootThunkDispatch>();
  const { binListRootState } = useSelector(
    (state: IRootState) => state.binListState,
  );
  const { selectedBinInBinGroup, originalBinGroup, newBinGroup } = useSelector(
    (state: IRootState) => state.binGroupListState,
  );

  function handleChangeBinGroupSequence(
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    bin_id: string,
  ) {
    const bin_group_sequence = event.target.value;
    dispatch(changeSelectedBinGroupSequenceAction(bin_group_sequence, bin_id));
  }

  function handleSelectedBin(
    newBin: SingleValue<SelectedBinListInBinGroup>,
    original_bin_id: string,
  ) {
    dispatch(changeSelectedBinInBinGroupAction(newBin, original_bin_id));
  }

  function handleChangeIsActive(event: ChangeEvent<HTMLInputElement>) {
    const is_active = event.target.value;
    dispatch(changeBinGroupIsActiveAction(is_active));
  }

  function handleClickAdd() {
    const randomIndex = Math.floor(Math.random() * binListRootState.length);
    const lastLocation = binListRootState[randomIndex];
    dispatch(addBinToSelectedBinInBinGroupAction(lastLocation));
  }

function handleClickRemove(bin_id: string) {
  dispatch(removeBinFromSelectedBinInBinGroupAction(bin_id));
}


  return (
    <Grid style={{ display: "flex", flexDirection: "column", gap: 30 }}>
      <Grid>
        <Grid> 現時：</Grid>
        <Grid style={{ display: "flex", gap: 30, flexWrap: "wrap" }}>
          {originalBinGroup && originalBinGroup.length > 0 ? (
            originalBinGroup.map((selectedToliet) => (
              <Grid
                key={`selectedBinInBinGroup-existed-${selectedToliet.bin_id as string}`}
              >
                <Grid>{selectedToliet.label}</Grid>

                <Grid>
                  <InputLabel htmlFor="date-picker">次序*</InputLabel>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    disabled
                    value={selectedToliet.bin_group_sequence}
                    fullWidth
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <>現時未有廁所地點</>
          )}
        </Grid>
      </Grid>

      <Grid style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <Grid> 更改：</Grid>

        <AddBinGroupForm />

        <FormControl>
          <FormLabel id="demo-row-radio-buttons-group-label">生效</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={newBinGroup.is_active.toString()}
            onChange={handleChangeIsActive}
          >
            <FormControlLabel value="1" control={<Radio />} label="生效" />
            <FormControlLabel value="0" control={<Radio />} label="註銷" />
          </RadioGroup>
        </FormControl>

        <Grid
          style={{
            display: "flex",
            gap: 30,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          {selectedBinInBinGroup && selectedBinInBinGroup.length > 0 ? (
            selectedBinInBinGroup.map((selectedToliet) => (
              <Grid
                key={`selectedBinInBinGroup-alter-${selectedToliet.bin_id as string}`}
              >
                <ReactSelect
                  options={binListRootState}
                  isSearchable
                  menuPlacement="auto"
                  menuPosition="fixed"
                  value={selectedToliet}
                  getOptionValue={(option) => option.bin_id!}
                  getOptionLabel={(option) => option.label}
                  onChange={(bin) =>
                    handleSelectedBin(bin, selectedToliet.bin_id!)
                  }
                />

                <Grid>
                  <InputLabel htmlFor="date-picker">次序*</InputLabel>
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(e) =>
                      handleChangeBinGroupSequence(
                        e,
                        selectedToliet.bin_id as string,
                      )
                    }
                    value={selectedToliet.bin_group_sequence}
                    fullWidth
                  />
                </Grid>
                <Grid style={{ display: "flex", justifyContent: "center" }} onClick={()=>handleClickRemove(selectedToliet.bin_id!)}>
                  <RemoveCircleIcon style={{ fontSize: 30, color: "red" }} />
                </Grid>
              </Grid>
            ))
          ) : (
            <>現時未有廁所地點</>
          )}

          <Grid onClick={handleClickAdd}>
            <AddCircleIcon style={{ color: "orange", fontSize: 50 }} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default BinGroupForm;
